import { render, staticRenderFns } from "./ModalBackdrop.vue?vue&type=template&id=b33fb58c&"
import script from "./ModalBackdrop.vue?vue&type=script&lang=js&"
export * from "./ModalBackdrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports